<!-- Compiled at 2026-05-13T13:50:05.286Z -->
<ng-container *ngIf="$isVariablesInitialized()">
	<ng-container *lowgileScope="null; screen: this; let $scope">
		<ng-container *lowgileForm="null; screen: this; let $formDirective">
			<div style="display: contents" [class.fill]="false">
				<mat-nav-list>
					<a
						mat-list-item
						mat-list-item
						routerLink="/ScanReceipt"
						[queryParams]="{}"
						routerLinkActive="is-current-link"
						target="_self"
						[style.--mat-list-list-item-leading-icon-start-space]="(16 + 0 * 24) + 'px'"
					>
						<span matListItemIcon
							><mat-icon
								[innerHtml]="'photo_camera'"
								fontSet="material-icons"
								[inline]="false"
							></mat-icon
						></span>
						<span matListItemTitle
							><span
								[innerHtml]="'Scan Receipt' | escapeHtml: 'none' | replaceNewlines: 'span'"
							></span
						></span>
					</a>

					<a
						mat-list-item
						mat-list-item
						routerLink="/VerifyExpenses"
						[queryParams]="{}"
						routerLinkActive="is-current-link"
						target="_self"
						[style.--mat-list-list-item-leading-icon-start-space]="(16 + 0 * 24) + 'px'"
					>
						<span matListItemIcon
							><mat-icon
								[innerHtml]="'check_circle_outline'"
								fontSet="material-icons"
								[inline]="false"
							></mat-icon
						></span>
						<span matListItemTitle
							><span
								[innerHtml]="'Verify Your Expenses' | escapeHtml: 'none' | replaceNewlines: 'span'"
							></span
						></span>
					</a>

					<a
						mat-list-item
						mat-list-item
						routerLink="/MyExpenses"
						[queryParams]="{}"
						routerLinkActive="is-current-link"
						target="_self"
						[style.--mat-list-list-item-leading-icon-start-space]="(16 + 0 * 24) + 'px'"
					>
						<span matListItemIcon
							><mat-icon
								[innerHtml]="'contact_mail'"
								fontSet="material-icons"
								[inline]="false"
							></mat-icon
						></span>
						<span matListItemTitle
							><span
								[innerHtml]="'My Expenses' | escapeHtml: 'none' | replaceNewlines: 'span'"
							></span
						></span>
					</a>

					<ng-container *ngIf="Sys.User.currentUser?.hasRole(This.$Roles.ExpenseManager)"
						><a
							mat-list-item
							mat-list-item
							routerLink="/InvoicePreparation"
							[queryParams]="{}"
							routerLinkActive="is-current-link"
							target="_self"
							[style.--mat-list-list-item-leading-icon-start-space]="(16 + 0 * 24) + 'px'"
						>
							<span matListItemIcon
								><mat-icon
									[innerHtml]="'receipt_long'"
									fontSet="material-icons"
									[inline]="false"
								></mat-icon
							></span>
							<span matListItemTitle
								><span
									[innerHtml]="'Invoice Preparation' | escapeHtml: 'none' | replaceNewlines: 'span'"
								></span
							></span>
						</a>

						<a
							mat-list-item
							mat-list-item
							routerLink="/AllExpenses"
							[queryParams]="{}"
							routerLinkActive="is-current-link"
							target="_self"
							[style.--mat-list-list-item-leading-icon-start-space]="(16 + 0 * 24) + 'px'"
						>
							<span matListItemIcon
								><mat-icon
									[innerHtml]="'receipt'"
									fontSet="material-icons"
									[inline]="false"
								></mat-icon
							></span>
							<span matListItemTitle
								><span
									[innerHtml]="'All Expenses' | escapeHtml: 'none' | replaceNewlines: 'span'"
								></span
							></span>
						</a>
					</ng-container>
				</mat-nav-list>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
